<script setup lang="ts">
  import Step1 from './steps/Step1.vue'
  import Step2 from './steps/Step2.vue'
  import { ref } from 'vue'

  const stepNumber = ref(1)

  function increaseStep() {
    stepNumber.value++
  }

  function currentStep() {
    if (stepNumber.value === 1) return Step1
    if (stepNumber.value === 2) return Step2
  }
</script>

<template>
  <component :is="currentStep()" @nextStep="increaseStep()"></component>
</template>
